// extracted by mini-css-extract-plugin
export var container = "_bc-0";
export var icon = "_bc-1";
export var text = "_bc-2";